import {
  keepPreviousData,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { useLocale } from 'next-intl';

type KeyPart = string | number | boolean | null | undefined;
type QueryKeyInput = string | readonly KeyPart[];

export const useLocalizedQuery = <TQueryFnData, TError>(
  key: QueryKeyInput,
  queryFn: (locale: string) => Promise<TQueryFnData>,
  options?: Omit<UseQueryOptions<TQueryFnData, TError>, 'queryKey' | 'queryFn'>,
) => {
  const locale = useLocale();
  const keyArr: readonly KeyPart[] = Array.isArray(key) ? key : [key];

  return useQuery<TQueryFnData, TError>({
    queryKey: [...keyArr, locale],
    queryFn: () => queryFn(locale),
    placeholderData: keepPreviousData,
    ...options,
  });
};
